import React from "react";
import logo from "../../../assets/images/inc-logo.png";
import customerSelectImg from "../../../assets/images/customers-select.png";
import "../../../assets/css/style.css";

const PrivacyAgreement = () => {
  return (
    <>
      <div className="headerpolicy">
        <div className="container">
          <img src={logo} alt="INC Logo" />
        </div>
      </div>

      <div className="main-wrapper">
        <div className="container">
          <h3 className="inc-heading">Privacy Policy</h3>

          <h4 className="inc-blue-heading">1. Definition of Policy</h4>
          <p style={{ paddingLeft: "2em" }}>
            1. The following Privacy Policy is adopted by VVDN (“VVDN” or “We”)
            in regards to the use of the Intelligent Network Controller Platform
            and related web pages and services (the “Service”), excluding
            affiliated websites covered by independent privacy policies. This
            Privacy Policy applies to information collected through the Service
            and otherwise (for example, if you contact us directly). However, it
            does not cover any information, whether personal or not, that may be
            collected through other websites or in other venues. Your use of the
            Service and our remaining services is subject to this Privacy
            Policy, which may be updated periodically to reflect changes in how
            we collect, use, and/or share information.
          </p>
          <p style={{ paddingLeft: "2em" }}>
            2. It is your responsibility to review this Privacy Policy together
            with the actual date of the change. Please check this Privacy Policy
            each time you use our Service to ensure you are aware of any changes
            in our practices. Your continued use of the Service will signify
            your acceptance of any changes to our Privacy Policy.
          </p>

          <h4 className="inc-blue-heading">2. Submission and Acceptance</h4>
          <p style={{ paddingLeft: "2em" }}>
            Your use of the Platform is also subject to VVDN’s Privacy Policy
            and other applicable policies. Continued use after changes to these
            Terms means you agree to the updated Terms.
          </p>

          <h4 className="inc-blue-heading">2.Collection</h4>
          <p style={{ paddingLeft: "2em" }}>
            1. You may not access the Service without providing some portion of
            required personal information to us. If you request receipt of
            certain notifications and updates, we will collect personally
            identifiable information, which you voluntarily give us. Said
            information may include your name, telephone number, email address,
            postal address, and any other information which would allow someone
            to personally identify you. Certain non-personally identifiable
            information, or non-PII, may also be collected when you use the
            Service, including the type of the Internet browser and operating
            system you use, region, other navigational clickstream data, etc.
          </p>
          <p style={{ paddingLeft: "2em" }}>
            2. You may collect personal information of individuals approached to
            use the Service by you (“Users”). You represent and warrant that
            your users accept this Privacy Policy and agree to share their
            personal data with you. You are liable for all and any breach of the
            personally identifiable information of Users.
          </p>
          <p style={{ paddingLeft: "2em" }}>
            3. Pursuant to the Service use, certain personal data and sensitive
            data can be collected by you with help of specific technical
            equipment for without limitation remote monitoring and control
            (“Networking Devices”). You represent and warrant that you have a
            legal right for such collection and Users agree upon said data
            collection.
          </p>
          <p style={{ paddingLeft: "2em" }}>
            4. We obtain information from third-party sources. For example, we
            may collect information about you from social networks, accounting
            services providers and data analytics providers. Additionally, if
            you create or log into your account through a third-party platform
            (such as Google, Facebook or GitHub etc.), we will have access to
            certain information from that platform, such as your name and email,
            in accordance with the authorization procedures determined by such
            platform.
          </p>

          <h4 className="inc-blue-heading">3. Purpose and Use</h4>
          <p style={{ paddingLeft: "2em" }}>
            1. VVDN uses the personally identifiable information to provide you
            with public information regarding us and our services; to share
            news, updates and reports in response to your inquiries; for gaining
            an understanding of your needs; for performing statistical analysis
            or analyses of global Service usage; for security and legal
            compliance; for notifying you of any changes to this Service or our
            remaining services; for billing; and for other services. We also
            reserve the right to make full use of information that is not
            personally identifiable information.
          </p>

          <h4 className="inc-blue-heading">4. Disclosure</h4>
          <p style={{ paddingLeft: "2em" }}>
            1. We will not sell, share, or rent your information to others
            except to our staff and to trusted third parties and affiliates when
            we need to share the information to provide a product or service you
            have requested. Without limiting the above, we will share your
            personal data with third parties only in the ways that are described
            in this Privacy Policy.
          </p>
          <p style={{ paddingLeft: "2em" }}>
            2. It may happen, the disclosure of your personally identifiable
            information would be necessary in response to a subpoena, court
            order, or a request for cooperation from law enforcement or other
            governmental agencies globally, in accordance with applicable law.
            Your personal data may also be shared when we believe disclosure is
            necessary in connection with efforts to investigate, prevent, or
            take other action regarding actual or suspected illegal activity or
            other wrongdoing, to protect and defend the rights, property or
            safety of the Service, VVDN Technologies, our users, or others.
          </p>
          <p style={{ paddingLeft: "2em" }}>
            3. We will use commercially reasonable efforts to make you aware of
            the disclosure of your personal information contrary to the terms
            set forth in this Privacy Policy (e.g., in the event of any material
            security breach).
          </p>

          <h4 className="inc-blue-heading">5. Third Parties</h4>
          <p style={{ paddingLeft: "2em" }}>
            1. The Service may contain links to other websites owned and
            operated by third parties. Said third parties and affiliates may
            collect information from you, their computer servers may be located
            outside your region. Browsing of Third Party websites and/or using
            their services out of the scope of this Privacy Policy. We do not
            control, and are not responsible for, the privacy and security
            practices of any third parties. Please acknowledge their privacy and
            security terms prior to any interaction with third parties.
          </p>

          <h4 className="inc-blue-heading">6. No tracking</h4>
          <p style={{ paddingLeft: "2em" }}>
            1. Nowadays some browsers provide the “Do Not Track” feature in a
            proprietary way. There is no common understanding of how to
            interpret Do Not Track requests. The Service does not currently
            respond to Do Not Track signals.
          </p>

          <h4 className="inc-blue-heading">7. Unsubscribe request</h4>
          <p style={{ paddingLeft: "2em" }}>
            1. By accepting the Terms of Use you subscribe to our newsletters
            and remain email campaigns without limitation. You can opt out at
            any time by using the unsubscribe links at the bottom of our emails.
            Our Service gives you the ability to delete all personal information
            from within the Service. You can completely delete your account and
            data by clicking the "Delete Account" button which is available on
            the User Profile Page. Please note, however, that we may need to
            retain certain information for record keeping purposes, to complete
            transactions or to comply with our legal obligations.
          </p>
        </div>
      </div>

      <footer>
        <div className="container">
          Powered by{" "}
          <a
            href="https://www.vvdntech.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            VVDN Technologies
          </a>
        </div>
      </footer>
    </>
  );
};

export default PrivacyAgreement;
